import { render, staticRenderFns } from "./typeform.vue?vue&type=template&id=0d5b375b&"
import script from "./typeform.vue?vue&type=script&lang=ts&"
export * from "./typeform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d5b375b')) {
      api.createRecord('0d5b375b', component.options)
    } else {
      api.reload('0d5b375b', component.options)
    }
    module.hot.accept("./typeform.vue?vue&type=template&id=0d5b375b&", function () {
      api.rerender('0d5b375b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/elements/typeform.vue"
export default component.exports